<nav class="navbar row w-100 mx-0 auth-page">
    <!-- logo -->
    <div class="navbar-brand">
      <a class="navbar-item">
        <img class="logo" src="assets/images/spaceil-logo-white.png">
      </a>
    </div>
    <div>
        <ul class="navbar-nav">
            <li class="nav-item" ngbDropdown>
                <a class="nav-link" ngbDropdownToggle id="languageDropdown" role="button">
                    <span *ngIf=" translate.currentLang === 'en' "><i class="flag-icon flag-icon-us mt-1" title="us"></i> <span class="font-weight-medium ml-1 mr-1 d-none d-md-inline-block">English</span></span>
                    <span *ngIf=" translate.currentLang === 'he' "><i class="flag-icon flag-icon-il mt-1" title="he"></i> <span class="font-weight-medium ml-1 mr-1 d-none d-md-inline-block">עברית</span></span>
                </a>
                <div ngbDropdownMenu aria-labelledby="languageDropdown">
                    <a ngbDropdownItem class="py-2" (click)="changeLang('en')" ><i class="flag-icon flag-icon-us" title="us" id="us"></i> <span class="ml-1"> English </span></a>
                    <a ngbDropdownItem class="py-2" (click)="changeLang('he')"><i class="flag-icon flag-icon-il" title="he" id="il"></i> <span class="ml-1"> עברית </span></a>
                </div>
            </li>
        </ul>
    </div>
  </nav>